<template>
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="11" r="10.25" stroke="currentColor" stroke-width="1.5" />
    <circle cx="5.16667" cy="10.6667" r="1.66667" fill="currentColor" />
    <circle cx="10.9997" cy="10.6667" r="1.66667" fill="currentColor" />
    <circle cx="16.8337" cy="10.6667" r="1.66667" fill="currentColor" />
  </svg>
</template>
